export enum InputHeight {
  default = '40px',
}
